/*
  La Magie de Lédy — téléversement réel d'une photo AVANT la réservation.

  Pourquoi : sur les prestations réservées via Appointo, l'app relit tous les
  champs [name*="properties"] de la page via `.value`. Pour un <input
  type="file">, le navigateur ne renvoie que "C:\fakepath\nom.jpg" : le
  fichier lui-même n'était jamais transmis (commande #1006).

  Fonctionnement :
  1. Dès que la cliente choisit une photo : contrôle du format (JPG, JPEG,
     PNG, HEIC/HEIF) et de la taille (15 Mo max).
  2. Le vrai fichier est envoyé au mécanisme natif de Shopify pour les
     fichiers de propriétés de ligne (/cart/add.js en multipart), sur une
     ligne temporaire d'un produit NON géré par Appointo (sinon Appointo
     retirerait la ligne et rechargerait la page). Shopify stocke le fichier
     sur son CDN et renvoie son URL définitive.
  3. La ligne temporaire est aussitôt retirée du panier (propriété préfixée
     "_" : jamais visible en panier/paiement, même en cas d'échec réseau ;
     un nettoyage est refait à chaque chargement et avant chaque envoi).
  4. L'URL est placée dans un champ caché name="properties[Photo]" : c'est
     ce texte (un lien cliquable) qui arrive dans la commande Shopify.
  Le champ fichier n'a volontairement PAS d'attribut name, pour que ni
  Appointo ni le formulaire natif ne puissent plus envoyer le faux chemin.
*/
(function () {
  if (window.LedyPhotoUpload) return;

  var MAX_BYTES = 15 * 1024 * 1024;
  var TEMP_PROPERTY = '_ledy_upload';
  var EXTENSIONS = /\.(jpe?g|png|heic|heif)$/i;
  var MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/pjpeg', 'image/png', 'image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence'];

  var MESSAGES = {
    format: 'Format non accepté : merci de choisir une photo au format JPG, PNG ou HEIC.',
    size: function (mb) {
      return 'Cette photo est trop lourde (' + mb + ' Mo). Taille maximale : 15 Mo. Merci de choisir une photo plus légère.';
    },
    uploading: 'Envoi de la photo en cours… merci de patienter.',
    done: 'Photo ajoutée ✓',
    error: "La photo n'a pas pu être envoyée. Merci de vérifier votre connexion et de réessayer.",
  };

  function uploadVariantId() {
    var el = document.querySelector('[data-ledy-upload-variant]');
    return el ? el.getAttribute('data-ledy-upload-variant') : '';
  }

  function validate(file) {
    if (!file) return null;
    var type = (file.type || '').toLowerCase();
    var okType = EXTENSIONS.test(file.name || '') || MIME_TYPES.indexOf(type) !== -1;
    if (!okType) return MESSAGES.format;
    if (file.size > MAX_BYTES) {
      return MESSAGES.size((file.size / (1024 * 1024)).toFixed(1).replace('.', ','));
    }
    return null;
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (res) {
      if (!res.ok) throw new Error('remove_failed');
    });
  }

  // Retire toute ligne temporaire restée dans le panier (coupure réseau…).
  function cleanTempLines() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : { items: [] };
      })
      .then(function (cart) {
        var keys = (cart.items || [])
          .filter(function (item) {
            return item.properties && item.properties[TEMP_PROPERTY];
          })
          .map(function (item) {
            return item.key;
          });
        return keys.reduce(function (p, key) {
          return p.then(function () {
            return removeLine(key);
          });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  function upload(file) {
    var variantId = uploadVariantId();
    if (!variantId) return Promise.reject(new Error('no_upload_variant'));
    return cleanTempLines().then(function () {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      fd.append('properties[' + TEMP_PROPERTY + ']', file, file.name);
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('upload_failed_' + res.status);
          return res.json();
        })
        .then(function (line) {
          var url = line && line.properties && line.properties[TEMP_PROPERTY];
          // L'URL est valable même si le retrait échoue : la ligne temporaire
          // sera retirée au prochain nettoyage, sans bloquer la cliente.
          var removal = line && line.key
            ? removeLine(line.key)
                .catch(function () {
                  return removeLine(line.key);
                })
                .catch(function () {})
            : Promise.resolve();
          return removal.then(function () {
            if (typeof url !== 'string' || url.indexOf('https://cdn.shopify.com/') !== 0) {
              throw new Error('no_cdn_url');
            }
            return url;
          });
        });
    });
  }

  /**
   * Relie un champ fichier à un champ caché qui recevra l'URL définitive.
   * @param {HTMLInputElement} fileInput
   * @param {{ target: HTMLInputElement|function(): HTMLInputElement, status?: HTMLElement }} opts
   * @returns {{ state: string, url: string }} état partagé, consultable avant de réserver
   */
  function bind(fileInput, opts) {
    if (!fileInput || fileInput.ledyPhoto) return fileInput && fileInput.ledyPhoto;
    var state = { state: 'empty', url: '' };
    fileInput.ledyPhoto = state;
    fileInput.removeAttribute('name');
    var status = opts.status;
    if (status) {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
    }

    function target() {
      return typeof opts.target === 'function' ? opts.target() : opts.target;
    }
    function setUrl(url) {
      var t = target();
      if (t) t.value = url;
      state.url = url;
    }
    function say(text) {
      if (status) status.textContent = text;
    }

    var attempt = 0;
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      var current = ++attempt;
      setUrl('');
      if (!file) {
        state.state = 'empty';
        say('');
        return;
      }
      var error = validate(file);
      if (error) {
        state.state = 'error';
        fileInput.value = '';
        say(error);
        return;
      }
      state.state = 'uploading';
      say(file.name + ' — ' + MESSAGES.uploading);
      upload(file).then(
        function (url) {
          if (current !== attempt) return;
          setUrl(url);
          state.state = 'done';
          say(file.name + ' — ' + MESSAGES.done);
        },
        function () {
          if (current !== attempt) return;
          state.state = 'error';
          fileInput.value = '';
          say(MESSAGES.error);
        }
      );
    });
    return state;
  }

  /**
   * Contrôle seul (format + taille), sans envoi anticipé : pour les champs
   * fichier envoyés par le formulaire natif (fiches produit hors Appointo),
   * où le fichier part réellement avec l'ajout au panier.
   */
  function bindValidateOnly(fileInput) {
    if (!fileInput || fileInput.ledyPhotoValidate) return;
    fileInput.ledyPhotoValidate = true;
    var msg = document.createElement('p');
    msg.className = 'ledy-service-fields__hint';
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    fileInput.insertAdjacentElement('afterend', msg);
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      var error = validate(file);
      if (error) fileInput.value = '';
      msg.textContent = error || '';
    });
  }

  /*
    Affichage seul : confirmation visible juste après le choix de la photo
    (miniature + « Photo sélectionnée ✓ »), sous le bouton de l'encart.
    Ne touche ni au champ, ni à l'envoi. Déclenchée par change ET input,
    plus une vérification courte après chaque toucher du bouton : sur
    iPhone, l'événement peut arriver tard après la fermeture de la
    photothèque.
  */
  var PREVIEW_CSS =
    '.ledy-photo-preview{display:flex;align-items:center;gap:.7em;margin-top:.7em;padding:.45em .9em .45em .45em;' +
    'border-radius:12px;background:rgba(85,17,68,.08);color:#551144;font-family:var(--font-body--family,inherit);' +
    'font-size:.9rem;font-weight:600;line-height:1.3;width:fit-content;max-width:100%;box-sizing:border-box}' +
    '.ledy-photo-preview[hidden]{display:none}' +
    '.ledy-photo-preview__thumb{width:48px;height:48px;object-fit:cover;border-radius:8px;flex:none;background:#fff}';

  function bindPreview(fileInput) {
    if (!fileInput || fileInput.ledyPhotoPreview) return;
    fileInput.ledyPhotoPreview = true;
    if (!document.getElementById('ledy-photo-preview-style')) {
      var style = document.createElement('style');
      style.id = 'ledy-photo-preview-style';
      style.textContent = PREVIEW_CSS;
      document.head.appendChild(style);
    }
    var box = document.createElement('div');
    box.className = 'ledy-photo-preview';
    box.hidden = true;
    var thumb = document.createElement('img');
    thumb.className = 'ledy-photo-preview__thumb';
    thumb.alt = '';
    thumb.width = 48;
    thumb.height = 48;
    thumb.onerror = function () {
      thumb.hidden = true; // ex. HEIC hors Safari : on garde le texte
    };
    var text = document.createElement('span');
    text.textContent = 'Photo sélectionnée ✓';
    box.appendChild(thumb);
    box.appendChild(text);
    var anchor = fileInput.closest('label') || fileInput;
    anchor.insertAdjacentElement('afterend', box);

    var shown = '';
    var objectUrl = '';
    function render() {
      var file = fileInput.files && fileInput.files[0];
      var key = file && !validate(file) ? file.name + '|' + file.size + '|' + file.lastModified : '';
      if (key === shown) return;
      shown = key;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = '';
      if (!key) {
        box.hidden = true;
        return;
      }
      objectUrl = URL.createObjectURL(file);
      thumb.hidden = false;
      thumb.src = objectUrl;
      box.hidden = false;
    }
    // Après les autres écouteurs (contrôle format/taille qui peut vider le champ).
    function later() {
      setTimeout(render, 0);
    }
    fileInput.addEventListener('change', later);
    fileInput.addEventListener('input', later);
    var timer = null;
    fileInput.addEventListener('click', function () {
      clearInterval(timer);
      var ticks = 0;
      timer = setInterval(function () {
        render();
        if (++ticks > 200) clearInterval(timer);
      }, 300);
    });
    render();
  }

  /*
    Affichage seul : les boutons des pages de prestation ajoutent au panier
    par leur propre appel /cart/add.js, que l'en-tête ne voit pas (seul le
    formulaire produit natif le prévient). Après un ajout réussi, on relit
    le panier et on passe le nombre d'articles au compteur du thème
    (<cart-icon>, sa propre méthode d'affichage).
  */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
        });
      })
      .catch(function () {});
  }

  window.LedyPhotoUpload = {
    bind: bind,
    validate: validate,
    upload: upload,
    messages: MESSAGES,
    refreshCartCount: refreshCartCount,
  };

  function autoBind() {
    document
      .querySelectorAll('.ledy-upload-mock input[type="file"], .ledy-service-fields input[type="file"]')
      .forEach(bindPreview);
    document.querySelectorAll('input[type="file"][data-ledy-photo-validate]').forEach(bindValidateOnly);
    cleanTempLines();
    document.querySelectorAll('input[type="file"][data-ledy-photo-target]').forEach(function (input) {
      bind(input, {
        target: document.getElementById(input.getAttribute('data-ledy-photo-target')),
        status: document.getElementById(input.getAttribute('data-ledy-photo-status')),
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoBind);
  } else {
    autoBind();
  }
})();
